export default "__VITE_ASSET__2mAy718e__"